<script setup lang="ts">
defineProps<{
    headline: string;
    copy: string;
    image: Record<string, any>;
    button: Record<string, any>;
}>();
</script>

<template>
    <section class="three-up-card card flex flex-col text-white rounded-(--radius) overflow-hidden bg-(--purple,#820CA7)">
        <div class="aspect-[426/289]" v-if="image">
            <MessImage v-if="image" :image="image" />
        </div>
        <div class="px-(--box-padding-lr-m) py-6 lg:p-10 flex flex-col grow">
            <MessHtml class="font-hubspot-serif text-[calc(36/var(--base-fs)*1rem)] font-normal leading-[1.2] tracking-normal mb-3"
                tag="h3" :html="headline" />
            <MessHtml class="text-white/80 font-hubspot-sans text-[calc(16/var(--base-fs)*1rem)] font-light leading-[26px] tracking-[0.32px] mb-8 last:mb-4"
                :html="copy" />
            <a v-if="button?.label" :href="button.url" :title="button.title" :target="button.target"
                class="mt-auto inline-flex self-start items-center gap-2.5
                    px-5 py-2.5 rounded-[50px]
                    bg-white text-(--magenta) no-underline
                    font-hubspot-serif text-[calc(17/var(--base-fs)*1rem)] leading-[1.4] tracking-[0.34px]
                    transition-colors duration-200
                    hover:bg-(--orange) hover:text-white
                    focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2">
                {{ button.label }}
            </a>
        </div>
    </section>
</template>
